import React from "react";
import { usePointPlacer } from "./hooks";
import { colors } from "../../utils/colors";
import { POINT_TYPE } from "./utils";
import { LineSegments } from "../threeDComponent/FilledPolygon";

const PointMesh = ({ followingSphereRef, meshProps, onClick, isVisible }) => {
  return (
    <mesh
      ref={followingSphereRef}
      {...meshProps}
      onClick={onClick}
      visible={isVisible}
    >
      <sphereGeometry args={[1, 8, 8]} />
      <meshStandardMaterial color={colors.red500()} transparent opacity={0.8} />
    </mesh>
  );
};

const MarkerMesh = ({ xMarkRef, meshProps, handlePlacePoint, isVisible }) => {
  return (
    <group ref={xMarkRef} onClick={handlePlacePoint}>
      <mesh rotation={[0, Math.PI / 4, 0]} {...meshProps} visible={isVisible}>
        <boxGeometry args={[2, 0.1, 0.1]} />
        <meshStandardMaterial color={colors.red500()} />
      </mesh>
      <mesh rotation={[0, -Math.PI / 4, 0]} {...meshProps} visible={isVisible}>
        <boxGeometry args={[2, 0.1, 0.1]} />
        <meshStandardMaterial color={colors.red500()} />
      </mesh>
    </group>
  );
};

const ConnectionLineMesh = ({ connectionLineRef, meshProps, isVisible }) => {
  return (
    <LineSegments
      lineRef={connectionLineRef}
      {...meshProps}
      visible={isVisible}
    />
  );
};

function PointPlacer({
  onPlacePoint,
  setEditingPosition,
  orbitRef,
  type = POINT_TYPE.POINT_WITH_MARKER,
  isAnimationActive = true,
  onSpherePositionChange,
  snapPosition,
}) {
  const liftY = type === POINT_TYPE.POINT_WITH_MARKER;
  const { handlePlacePoint, refs, meshProps, isVisible } = usePointPlacer(
    orbitRef,
    setEditingPosition,
    onPlacePoint,
    liftY,
    isAnimationActive,
    onSpherePositionChange,
    snapPosition
  );

  const { followingSphereRef, xMarkRef, connectionLineRef } = refs;

  const visibility = {
    [POINT_TYPE.POINT_WITH_MARKER]: {
      point: true,
      marker: true,
      connectionLine: true,
    },
    [POINT_TYPE.INVISIBLE_POINT]: {
      point: false,
      marker: false,
      connectionLine: false,
    },
  };

  return (
    <group visible={isVisible}>
      <PointMesh
        followingSphereRef={followingSphereRef}
        meshProps={meshProps}
        isVisible={visibility[type].point}
      />
      <group>
        <MarkerMesh
          xMarkRef={xMarkRef}
          meshProps={meshProps}
          handlePlacePoint={handlePlacePoint}
          isVisible={visibility[type].marker}
        />
        <ConnectionLineMesh
          connectionLineRef={connectionLineRef}
          meshProps={meshProps}
          isVisible={visibility[type].connectionLine}
        />
      </group>
    </group>
  );
}

export default PointPlacer;
